import React  from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TablePagination from '@mui/material/TablePagination';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import AttachmentIcon from '@mui/icons-material/Attachment';
import { formatName } from '../../common/common';


const API_URL = process.env.REACT_APP_API_URL;
export const EventList  = props => {
     const [page, setPage] = React.useState(0);
     const [rowsPerPage, setRowsPerPage] = React.useState(10);
     const handleChangePage = (event, newPage) => {
      setPage(newPage);
      };
    const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    };

    return (
        <React.Fragment>
                <TableContainer component={Paper}>
                <Table  aria-label="Timesheet List" className={'list-table_basic steps-table'}>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            {(props.Tab !== 'my') && (props.Requests.length !== 0) &&
                            <TableCell>Staff Name</TableCell>
                            }
                            <TableCell>Event Date</TableCell>
                            <TableCell>Eligibility Period</TableCell>
                            <TableCell>Event Type</TableCell>
                            <TableCell>Request For</TableCell>
                            <TableCell>Status</TableCell>
                            {(props.Tab !== 'my') && (props.Requests.length !== 0) &&
                            <TableCell>Submitted by</TableCell>
                            }
                            <TableCell>Submitted on</TableCell>
                            <TableCell>Reviewed by</TableCell>
                            <TableCell>Reviewed on</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody className={'tbody'}>
                         {(props.Requests) && (props.Requests.length === 0) &&
                            <TableRow >
                                <TableCell colSpan="5">No Event Requests found.</TableCell>
                            </TableRow>
                        }
                        {props.Requests.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) =>
                        <TableRow hover>
                            <TableCell><a className={'item-link'} onClick={()=>props.HandleViewClick(row.id)}>{row.id}</a></TableCell>
                            {(props.Tab !== 'my') &&
                                <TableCell>
                                    <a className={'item-link'} onClick={()=>props.ViewStaffDetails(row.user_ids)}>
                                        {formatName(row.cby_first_name, null, row.cby_last_name)}
                                    </a>
                                </TableCell>
                            }
                            <TableCell>{row.event_date}</TableCell>
                            <TableCell  width = '200px'>{row.start_date} - {row.end_date}</TableCell>
                            <TableCell>{row.type}</TableCell>
                            <TableCell>{row.to_type}</TableCell>
                            <TableCell>{row.request_status_name}</TableCell>
                             {(props.Tab !== 'my') &&
                            <TableCell>{formatName(row.cby_first_name, null, row.cby_last_name)}</TableCell>
                            }

                            <TableCell>{row.submitted_date}</TableCell>
                            <TableCell>{row.rev_name}</TableCell>
                            <TableCell>{row.reviewed_on}</TableCell>
                            <TableCell align="right" width = '200px'>
                             {(props.EditPermission && props.Tab == 'my' && (row.status == 1 || row.status == 3 || row.status == 5)) &&
                                <Tooltip title="Edit" aria-label="edit">
                                    <IconButton   className={'action-btn'} edge="end" aria-label="Comments">
                                    <EditIcon fontSize="small" onClick={()=>props.CreateEvent(row.id)}/>
                                    </IconButton>
                                </Tooltip>
                             }
                                <Tooltip title="View" aria-label="view">
                                    <IconButton  className={'action-btn'} edge="end" aria-label="Comments">
                                    <VisibilityIcon fontSize="small" onClick={()=>props.HandleViewClick(row.id)}/>
                                    </IconButton>
                                </Tooltip>
                            {(row.attachement_id != null) &&
                                <IconButton   className={'action-btn'} edge="end" aria-label="Attachment">
                                        <a href = {API_URL+'api/request/timeoff/download?id='+ row.attachement_id}>  <AttachmentIcon  fontSize="small"/> </a>
                                    </IconButton>
                             }
                            </TableCell>

                        </TableRow>
                        )}
                    </TableBody>
                </Table>
              </TableContainer>
         <TablePagination
        rowsPerPageOptions={[5, 10, 15]}
        component="div"
        count={props.Requests.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

        </React.Fragment>
    )
}

